var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fccTable',{attrs:{"striped":"","hover":"","fields":_vm.fieldsBotoes,"orderby":_vm.sortBy,"actions":_vm.actions,"optionsButton":_vm.optionSolicitacoes,"items":_vm.lstBotoes,"responsive":"","porPage":_vm.itemPorPage,"titlePage":_vm.titlePage,"titlePDF":_vm.titlePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }